import './main.css';
import React from 'react';
import { render } from 'react-dom';
import App from './content/app.js';

render((<App/>), document.getElementById('root'));
